// extracted by mini-css-extract-plugin
export default {"wrapper":"_W7I2Tf5","Tooltip":"gT6zRT4E"};